/**
 * Canonical gate for the Semantic Connectors module.
 *
 * Resolves Entitlement → Workspace module → Module policy → Personal flag
 * via the one policy-aware gate (build contract §2.7). Never check
 * isModuleEnabled/isFeatureEnabled inline for excursion surfaces — use this.
 */

import { useModuleGate } from '../../../lib/moduleGate';

export function useSemanticConnectorsEnabled(): boolean {
  return useModuleGate('semantic_connectors');
}
